(function(){
  if (window.__iclLanderInit) return;   /* asset copy and inline copy must not double-bind */
  window.__iclLanderInit = 1;
  function init(){
  var $=function(s,r){return (r||document).querySelector(s)},
      $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  /* See It In Action: hover plays muted, click toggles audio, click again mutes.
     Sits ABOVE the buy-box guard so the marquee still works on any lander that
     has clips but no buy box. */
  (function(){
    var clips = $$('.icl-clip'); if(!clips.length) return;
    function mute(c){
      var v = c.querySelector('video'); if(!v) return;
      v.muted = true; c.setAttribute('data-icl-audio','off');
    }
    function muteAll(except){
      clips.forEach(function(c){ if (c !== except) mute(c); });
    }
    function play(v){ var p = v.play(); if (p && p.catch) p.catch(function(){}); }
    clips.forEach(function(c){
      var v = c.querySelector('video'); if(!v) return;
      v.muted = true;
      c.addEventListener('mouseenter', function(){ play(v); });
      c.addEventListener('mouseleave', function(){ v.pause(); mute(c); });
      c.addEventListener('click', function(){
        if (v.muted){
          muteAll(c);                       /* only ever one clip audible */
          v.muted = false;
          c.setAttribute('data-icl-audio','on');
          play(v);
        } else {
          mute(c);                          /* mute, but keep playing */
        }
      });
    });

    /* white "click to mute/unmute" label stands in for the pointer */
    var vp = $('.icl-clips-viewport'), lbl = $('.icl-clips-cursor');
    if (vp && lbl && !(window.matchMedia && window.matchMedia('(hover:none)').matches)){
      var cx = 0, cy = 0, raf = 0;
      /* clamped to the media band: white text spilling onto the light page
         background below the tiles is unreadable */
      function draw(){
        raf = 0;
        var r = vp.getBoundingClientRect();
        var x = Math.min(Math.max(cx + 16, r.left + 10), r.right - lbl.offsetWidth - 10);
        var y = Math.min(Math.max(cy + 16, r.top + 10), r.bottom - lbl.offsetHeight - 10);
        lbl.style.transform = 'translate3d('+x+'px,'+y+'px,0)';
      }
      vp.addEventListener('pointermove', function(e){
        cx = e.clientX; cy = e.clientY;
        if (!raf) raf = requestAnimationFrame(draw);
      }, {passive:true});
      vp.addEventListener('pointerenter', function(e){
        cx = e.clientX; cy = e.clientY; draw();
        lbl.setAttribute('data-icl-on','');
      });
      vp.addEventListener('pointerleave', function(){ lbl.removeAttribute('data-icl-on'); });
    }
    window.__iclClips = { count: clips.length, muteAll: muteAll };
  })();

  var box = $('.icl-buybox');
  if(!box) return;
  var C = { base: {
    variant:   parseInt(box.getAttribute('data-base-variant'),10),
    price:     parseInt(box.getAttribute('data-base-price'),10),
    cmp:       parseInt(box.getAttribute('data-base-cmp')||'0',10) || null,
    available: box.getAttribute('data-base-available') !== 'false'
  }};
  /* Presentment currency comes from the market Liquid rendered this page for
     (NZD on ironcladpan.com, AUD on ironcladpan.com.au) — never hardcode it. */
  var CUR = box.getAttribute('data-currency') || 'NZD';
  /* Steak-press bundle (pure-legacy-press only): PRESS stays null on
     every other lander — these attrs are rendered there by no template. */
  var PRESS = box.getAttribute('data-press-variant') ? {
    variant: parseInt(box.getAttribute('data-press-variant'),10),
    price:   parseInt(box.getAttribute('data-press-price'),10),
    disc:    parseInt(box.getAttribute('data-discount-cents'),10) || 0,
    code:    box.getAttribute('data-discount-code') || ''
  } : null;
  /* store money format: whole dollars show no cents ("$300"), fractions keep them */
  function fmt(c){
    var d = c/100, whole = (c % 100) === 0;
    return '$'+d.toLocaleString('en-NZ',{minimumFractionDigits: whole?0:2, maximumFractionDigits: whole?0:2});
  }

  /* gallery carousel: one full-height slide + "< 1/6 >" pager (Ridge-style) */
  (function(){
    var track = document.getElementById('SlidesCon');
    if(!track || !track.classList.contains('icl-car-track')) return;
    var slides = $$('.icl-car-slide', track), cur = document.getElementById('icl-car-cur');
    function idx(){ return Math.min(slides.length, Math.max(1, Math.round(track.scrollLeft / track.clientWidth) + 1)); }
    window.changeSlide = function(el, n){
      n = ((n - 1) % slides.length + slides.length) % slides.length + 1;   /* wrap like Ridge */
      var s = track.querySelector('.icl-car-slide[data-slide-index="'+n+'"]');
      if(s) track.scrollTo({left: s.offsetLeft, behavior:'smooth'});
      if(cur) cur.textContent = n;
    };
    var prev = $('.icl-car-prev'), next = $('.icl-car-next');
    if(prev) prev.addEventListener('click', function(){ changeSlide(null, idx()-1); });
    if(next) next.addEventListener('click', function(){ changeSlide(null, idx()+1); });
    var st; track.addEventListener('scroll', function(){
      clearTimeout(st); st = setTimeout(function(){ if(cur) cur.textContent = idx(); }, 90);
    }, {passive:true});
    /* kick muted autoplay — some browsers stay at readyState 0 with preload=metadata */
    $$('.icl-car-slide video', track).forEach(function(v){
      v.muted = true;
      var p = v.play(); if (p && p.catch) p.catch(function(){});
    });
  })();

  /* star rating badge: Klaviyo metafields via Liquid, baked values as fallback */
  (function(){
    var el = $('.icl-rating'); if(!el) return;
    function num(x){
      if(x==null || x==='') return NaN;
      try{ var v = JSON.parse(x); if(typeof v==='object' && v) v = v.value!=null?v.value:v.rating; return parseFloat(v); }
      catch(e){ var m = String(x).match(/-?\d+(\.\d+)?/); return m?parseFloat(m[0]):NaN; }
    }
    var r = num(el.getAttribute('data-rating')), c = parseInt(el.getAttribute('data-count'),10);
    if(!(r>0)) r = parseFloat(el.getAttribute('data-default-rating'));
    if(!(c>0)) c = parseInt(el.getAttribute('data-default-count'),10);
    if(!(r>0) || !(c>0)) return;
    var fill = el.querySelector('.icl-rating-stars-fill');
    if(fill) fill.style.width = (Math.max(0, Math.min(5, r))/5*100) + '%';
    var ct = el.querySelector('.icl-rating-count');
    if(ct) ct.textContent = c.toLocaleString('en-NZ') + (c===1?' review':' reviews');
    el.removeAttribute('hidden');
  })();

  /* reviews: hide the static replica once the live Klaviyo widget hydrates */
  (function(){
    var shell = document.getElementById('reviews-all') || document.getElementById('fulfilled-reviews-all'),
        fb = $('[data-icl-fallback]');
    if(!shell || !fb) return;
    var tries = 0;
    (function check(){
      var live = document.getElementById('fulfilled-reviews-all') || shell;
      if(live.children.length > 0){ fb.setAttribute('data-icl-hidden',''); return; }
      if(++tries < 40) setTimeout(check, 250);
    })();
  })();

  /* tabs */
  $$('.product-info-tabs').forEach(function(w){
    var btns=$$('.tab-button',w), panels=$$('.tab-content',w);
    btns.forEach(function(b,i){ b.addEventListener('click',function(){
      btns.forEach(function(x,j){ x.setAttribute('aria-selected', i===j); });
      panels.forEach(function(p,j){ if(i===j){p.removeAttribute('hidden');}else{p.setAttribute('hidden','hidden');} });
    });});
  });

  /* accordions — only act if the theme script didn't already handle it */
  $$('.accordion .accordion-title').forEach(function(btn){
    btn.addEventListener('click', function(){
      var before = btn.getAttribute('aria-expanded');
      setTimeout(function(){
        if(btn.getAttribute('aria-expanded') !== before) return;
        var open = before !== 'true';
        btn.setAttribute('aria-expanded', open);
        var p = document.getElementById(btn.getAttribute('aria-controls'));
        if(p) p.setAttribute('aria-hidden', !open);
      }, 0);
    });
  });

  /* add-on detail toggles */
  $$('.icl-chev').forEach(function(ch){
    ch.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation();
      ch.closest('.icl-addon').classList.toggle('open'); });
  });

  /* buy box */
  var state={upgrade:null, base:C.base};
  var atc=$('#icl-atc'), ap=$('#icl-afterpay');
  var pn=$('#icl-price-now'), ps=$('#icl-price-sale'), pc=$('#icl-price-cmp'), pw=$('.product-price-block .price');
  function cur(){ return state.upgrade || state.base; }
  function recalc(){
    var b=cur(); if(!b||!atc) return;
    var items=[b.variant+':1'], total=b.price, cmpTotal=(b.cmp||b.price);
    if (PRESS){ items.push(PRESS.variant+':1'); total+=PRESS.price-PRESS.disc; cmpTotal+=PRESS.price-PRESS.disc; }
    $$('.icl-addon input:checked').forEach(function(cb){
      items.push(cb.value+':1'); total+=parseInt(cb.getAttribute('data-price'),10);
      cmpTotal+=parseInt(cb.getAttribute('data-cmp')||cb.getAttribute('data-price'),10);
    });
    var href='/cart/'+items.join(',')+(PRESS&&PRESS.code?'?discount='+PRESS.code:'');
    atc.setAttribute('href',href);
    if(!b.available){ atc.classList.add('disabled'); atc.textContent='Sold Out'; }
    else { atc.classList.remove('disabled'); atc.textContent='Add to Cart  —  '+fmt(total)+' '+CUR; }
    if(ap) ap.textContent = b.available ? ('or 4 interest-free payments of '+fmt(Math.round(total/4))+' with Afterpay') : '';
    var sale = b.cmp && b.cmp>b.price;
    var pbase=b.price+(PRESS?PRESS.price-PRESS.disc:0);
    if(pn) pn.textContent=fmt(pbase)+' '+CUR;
    if(ps) ps.textContent=fmt(pbase)+' '+CUR;
    if(pc) pc.textContent = sale ? (fmt(b.cmp)+' '+CUR) : '';
    if(pw) pw.classList.toggle('price--on-sale', !!sale);
    /* sticky bar mirrors the ATC, with the compare-at total struck through on deals */
    var sb=$('#icl-atc-sticky-btn');
    if(sb){
      if(!b.available){ sb.classList.add('disabled'); sb.textContent='Sold Out'; }
      else {
        sb.classList.remove('disabled'); sb.setAttribute('href',href);
        sb.innerHTML='Add to Cart&nbsp;&nbsp;|&nbsp;&nbsp;'+fmt(total)+' '+CUR
          +(cmpTotal>total ? '&nbsp;&nbsp;<s>'+fmt(cmpTotal)+'</s>' : '');
      }
    }
  }
  /* multi-pan add-ons appear only when the matching set is chosen */
  function applyReveal(kind){
    $$('.icl-addon[data-reveal]').forEach(function(el){
      var ok = kind && el.getAttribute('data-reveal').split(/\s+/).indexOf(kind) > -1;
      if(ok){ el.removeAttribute('hidden'); }
      else {
        el.setAttribute('hidden','hidden');
        el.classList.remove('open');
        var cb = el.querySelector('input'); if(cb) cb.checked = false;   // never bill a hidden add-on
      }
    });
  }

  $$('.icl-up').forEach(function(btn){
    btn.addEventListener('click', function(){
      if(btn.disabled) return;
      var was = state.upgrade && state.upgrade.key===btn.getAttribute('data-key');
      $$('.icl-up').forEach(function(b){ b.setAttribute('aria-pressed','false'); });
      if(was){ state.upgrade=null; }
      else {
        state.upgrade={key:btn.getAttribute('data-key'),
          kind:btn.getAttribute('data-kind'),
          variant:parseInt(btn.getAttribute('data-variant'),10),
          price:parseInt(btn.getAttribute('data-price'),10),
          cmp:parseInt(btn.getAttribute('data-cmp')||'0',10)||null,
          available:btn.getAttribute('data-available')==='true'};
        btn.setAttribute('aria-pressed','true');
      }
      applyReveal(state.upgrade ? state.upgrade.kind : null);
      recalc();
    });
  });
  $$('.icl-vsw').forEach(function(sw){
    sw.addEventListener('click', function(e){
      e.preventDefault();
      $$('.icl-vsw').forEach(function(b){ b.classList.remove('selected'); });
      sw.classList.add('selected');
      state.base={variant:parseInt(sw.getAttribute('data-variant'),10),
        price:parseInt(sw.getAttribute('data-price'),10),
        cmp:parseInt(sw.getAttribute('data-cmp')||'0',10)||null,
        available:sw.getAttribute('data-available')==='true'};
      var lbl=$('#icl-colour-val'); if(lbl) lbl.textContent=sw.getAttribute('data-name');
      /* colour-matched add-ons (lid duo) follow the selected colour */
      var cname=(sw.getAttribute('data-name')||'').toLowerCase();
      var ckey = cname.indexOf('olive')>-1 ? 'olive' : (cname.indexOf('salt')>-1 ? 'salt' : 'black');
      $$('.icl-addon input[data-cmap]').forEach(function(cb){
        try{ var m=JSON.parse(cb.getAttribute('data-cmap')); if(m && m[ckey]) cb.value=m[ckey]; }catch(e){}
      });
      state.upgrade=null;
      $$('.icl-up').forEach(function(b){ b.setAttribute('aria-pressed','false'); });
      applyReveal(null);
      recalc();
    });
  });
  $$('.icl-addon input').forEach(function(cb){ cb.addEventListener('change', recalc); });
  recalc();

  /* show the sticky bar once the buy box's ATC scrolls above the viewport.
     Scroll listener rather than IntersectionObserver: observers are throttled
     in background tabs and this must also work in older mobile browsers. */
  (function(){
    var stk = document.getElementById('icl-atc-sticky');
    if(!stk || !atc) return;
    function upd(){ stk.classList.toggle('visible', atc.getBoundingClientRect().bottom < 0); }
    window.__iclStickyUpdate = upd;
    window.addEventListener('scroll', upd, {passive:true});
    window.addEventListener('resize', upd, {passive:true});
    upd();
  })();

  /* carousel: cap slide height so the media never runs past the fold */
  (function(){
    var vp = $('.icl-car-viewport'); if(!vp) return;
    function fit(){
      if (window.innerWidth < 990) { vp.style.removeProperty('--icl-car-max'); return; }
      var top = vp.getBoundingClientRect().top + (window.scrollY || 0);
      var h = Math.max(380, Math.round(window.innerHeight - top - 24));
      vp.style.setProperty('--icl-car-max', h + 'px');
    }
    window.__iclCarFit = fit;
    window.addEventListener('resize', fit, {passive:true});
    window.addEventListener('load', fit);
    fit();
  })();

  /* reviews: reveal the remaining reviews */
  (function(){
    var btn = $('.icl-krev-more'); if(!btn) return;
    btn.addEventListener('click', function(){
      $$('.icl-krev-hidden').forEach(function(el){ el.removeAttribute('hidden'); });
      btn.remove();
    });
  })();
  }
  /* runs wherever the tag sits in the document */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
